import React, { useState } from "react";
import WhiteButton from "../WhiteButton/WhiteButton";
import "./CustomScheduleBanner.scss";
import Sparkles from "react-sparkle";

function CustomScheduleBanner(props) {
  return (
    <div
      className="custom-schedule-banner"
      style={props.style ? props.style : {}}
    >

      <div className="left">
        <h3>Custom Schedule Beta</h3>
        <h2>Get a Study Schedule</h2>
        <p>
          Click Get Started and we'll make you a schedule to learn all of these
          terms.
        </p>
        <WhiteButton
          text="Get Started"
          hoverColor="#622be2"
          onClick={() => {
            window.location.href = "https://quizzynow.com/upgrade";
          }}
        ></WhiteButton>
      </div>
      
    </div>
  );
}

export default CustomScheduleBanner;
